<template>
    <div class="container">
        <div class="col-12">
            <div class="row text-center">
                <div class="divider"></div>
                <h4>
                    <span class="title-divider text-uppercase">{{ title }}</span>
                </h4>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "title-divider",

        props: {
            title: {
                type: String,
                required: false
            }
        }
    }
</script>

<style scoped>

    .divider {
        height: 3px;
        margin-top: 40px;
        margin-bottom: -22px;
        background-color: #f84a5f;
    }

    .title-divider {
        background-color: #efefef;
        padding: 0px 40px;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TitleDivider.vue